'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /** The alt of the image to be loaded */
  alt: _propTypes2.default.string,
  /** Optional error component to show when image failed to load */
  error: _propTypes2.default.node,
  /** Optional props for the img element */
  imgProps: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when loading throws an error
   *
   * function(event: object) => void
   */
  onError: _propTypes2.default.func,
  /**
   * Callback fired when image is finished loading
   *
   * function(event: object) => void
   */
  onLoad: _propTypes2.default.func,
  /** Placeholder to show while the image is loading */
  placeholder: _propTypes2.default.node,
  /** The URL of the image to be loaded */
  src: _propTypes2.default.string.isRequired
};

var defaultProps = {
  alt: '',
  error: null,
  imgProps: {},
  onError: _noop2.default,
  onLoad: _noop2.default,
  placeholder: null
};

var displayName = 'ImageLoader';

/* Show a placeholder while an image is loading or an error when an image fails to load. */

var ImageLoader = function (_Component) {
  _inherits(ImageLoader, _Component);

  function ImageLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageLoader.__proto__ || Object.getPrototypeOf(ImageLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      status: 'loading'
    }, _this.handleError = function (error) {
      var onError = _this.props.onError;


      _this.destroy();

      _this.setState({
        status: 'failed'
      });

      onError(error);
    }, _this.handleLoad = function (e) {
      var onLoad = _this.props.onLoad;


      _this.destroy();

      _this.setState({
        status: 'loaded'
      });

      onLoad(e);
    }, _this.create = function () {
      var src = _this.props.src;


      _this.destroy();

      _this.img = new Image();
      _this.img.onload = _this.handleLoad;
      _this.img.onerror = _this.handleError;
      _this.img.src = src;
    }, _this.destroy = function () {
      if (_this.img) {
        _this.img.onload = null;
        _this.img.onerror = null;
        _this.img = null;
      }
    }, _this.renderImage = function () {
      var _this$props = _this.props,
          src = _this$props.src,
          alt = _this$props.alt,
          imgProps = _this$props.imgProps;


      return _react2.default.createElement('img', _extends({ src: src, alt: alt }, imgProps));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var src = this.props.src;
      var status = this.state.status;


      if (src && status === 'loading') {
        this.create();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var src = this.props.src;


      if (src !== nextProps.src) {
        this.setState({
          status: 'loading'
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var src = this.props.src;
      var status = this.state.status;


      if (src && status === 'loading' && !this.img) {
        this.create();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          placeholder = _props.placeholder,
          error = _props.error,
          src = _props.src;
      var status = this.state.status;


      if (!src) {
        return null;
      }

      if (status === 'loaded') {
        return this.renderImage();
      }

      if (status === 'failed') {
        return error;
      }

      return placeholder;
    }
  }]);

  return ImageLoader;
}(_react.Component);

ImageLoader.propTypes = propTypes;
ImageLoader.defaultProps = defaultProps;
ImageLoader.displayName = displayName;

exports.default = ImageLoader;
module.exports = exports.default;